module.exports = __webpack_public_path__ + "static/coliving-kitchen-02b66a2ffec35af8c1a527323dc623ea.jpg";